import type { TourConfig } from '../types';
import { CursorIcon } from '../icons/CursorIcon';
import { FeatherIcon } from '../icons/FeatherIcon';
import { BranchIcon } from '../icons/BranchIcon';

/**
 * 3-step orientation tour shown to first-time authenticated users when
 * they land on /library. Anchor names map 1:1 to useTourAnchor() calls in
 * the corresponding components.
 */
export const libraryOnboardingTour: TourConfig = {
  id: 'library-onboarding',
  gate: {
    storageKey: 'library',
    shouldRun: ({ pathname, viewportOk, searchParams }) => {
      const mode = searchParams.get('mode');
      return (
        pathname.startsWith('/library') &&
        // While the user is in edit mode the edit tour takes precedence — the
        // library tour shouldn't compete for attention there.
        mode !== 'edit' &&
        // In review mode the BottomToolbar (which hosts the editToggle anchor)
        // is swapped out for ReviewBottomToolbar, so step 2 can never resolve.
        // Reviewers aren't the audience for an authoring orientation anyway.
        mode !== 'review' &&
        viewportOk
      );
    },
  },
  steps: [
    {
      id: 'sidebar',
      anchorName: 'sidebar',
      title: 'Navigate',
      body: 'Find all categories and accessible documents here',
      icon: CursorIcon,
      side: 'right',
      align: 'start',
    },
    {
      id: 'edit',
      anchorName: 'editToggle',
      title: 'Edit articles',
      body: 'Editing is easy too! **Toggle** to edit mode to start editing.',
      icon: FeatherIcon,
      side: 'top',
      align: 'start',
    },
    {
      id: 'branch',
      anchorName: 'branchSelector',
      title: 'Branch your work',
      body: '**Click** to create your branch and only publish when you are sure it\'s good.',
      icon: BranchIcon,
      side: 'top',
      align: 'center',
    },
  ],
};
